import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import hoistNonReactStatics from 'hoist-non-react-statics';
import Wix from '../services/wix-sdk-polyfill';
import createHocName from '../services/create-hoc-name';
import { trackPerformance } from '../actions/track-performance';
import { PERFORMANCE_TEST_SITE_MSID } from '../constants/sites';
import { isSite } from '../selectors/view-mode-selectors';

const withPerformanceTracking = ({ context, skip = () => false } = {}) => WrappedComponent => {
  class WithPerformanceTracking extends React.Component {
    static displayName = createHocName('WithPerformanceTracking', WrappedComponent);

    isWixAutomation = () =>
      typeof navigator !== 'undefined' &&
      typeof navigator.userAgent === 'string' &&
      navigator.userAgent.includes('wixAutomation');

    shouldTrack = () =>
      !skip() &&
      this.props.isSite &&
      this.isWixAutomation() &&
      Wix.Utils.getInstanceValue('metaSiteId') === PERFORMANCE_TEST_SITE_MSID;

    handleLoad = () => this.shouldTrack() && this.props.trackPerformance({ context });

    componentDidMount = () => window.addEventListener('load', this.handleLoad);

    componentWillUnmount = () => window.removeEventListener('load', this.handleLoad);

    render = () => <WrappedComponent {...this.props} />;
  }

  hoistNonReactStatics(WithPerformanceTracking, WrappedComponent);

  WithPerformanceTracking.propTypes = {
    isSite: PropTypes.bool.isRequired,
    trackPerformance: PropTypes.func.isRequired,
  };

  const mapStateToProps = state => ({
    isSite: isSite(state),
  });

  const mapDispatchToProps = {
    trackPerformance,
  };

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(WithPerformanceTracking);
};

export default withPerformanceTracking;
